import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_navbar/experiments-v2')({
  beforeLoad: () => {
    throw redirect({ to: '/experiments' });
  },
});
